(() => {
  if (window.ddPlayfulInitialized) return;
  window.ddPlayfulInitialized = true;
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let language = 'th';
  let paused = reduced.matches;
  try { language = localStorage.getItem('dd-language') === 'en' ? 'en' : 'th'; paused ||= localStorage.getItem('dd-motion') === 'paused'; } catch (_) { /* Storage is optional. */ }
  function updateMotionControls() {
    document.querySelectorAll('.dd-motion-toggle').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = language === 'th' ? (paused ? 'เปิดภาพเคลื่อนไหว' : 'หยุดภาพเคลื่อนไหว') : (paused ? 'Play animation' : 'Pause animation');
      button.setAttribute('aria-label', button.textContent);
    });
  }
  function setLanguage(next) {
    language = next;
    root.dataset.ddLanguage = next;
    root.lang = next;
    document.querySelectorAll('[data-dd-th]').forEach(element => {
      element.textContent = (next === 'en' ? element.dataset.ddEn : element.dataset.ddTh) || element.dataset.ddTh;
    });
    document.querySelectorAll('[data-dd-label-th]').forEach(element => element.setAttribute('aria-label', next === 'en' ? element.dataset.ddLabelEn : element.dataset.ddLabelTh));
    document.querySelectorAll('[data-dd-alt-th]').forEach(element => element.alt = next === 'en' ? element.dataset.ddAltEn : element.dataset.ddAltTh);
    document.querySelectorAll('[data-dd-language-scope]').forEach(element => element.lang = next);
    document.querySelectorAll('[data-dd-lang]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ddLang === next)));
    updateMotionControls();
    try { localStorage.setItem('dd-language', next); } catch (_) { /* Keep working without storage. */ }
  }
  function setPaused(value) {
    paused = value;
    root.classList.toggle('dd-motion-paused', paused);
    if (paused) document.querySelectorAll('.dd-reveal-ready').forEach(element => element.classList.add('dd-visible'));
    updateMotionControls();
    try { localStorage.setItem('dd-motion', paused ? 'paused' : 'playing'); } catch (_) { /* Optional preference. */ }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('dd-visible'); observer.unobserve(entry.target); } });
  }, { threshold: .08 }) : null;
  function initialize() {
    setLanguage(language);
    setPaused(paused);
    document.querySelectorAll('.dd-category,.dd-story-art,.dd-story-copy,.dd-launch,.dd-channel,.dd-faq-item,.dd-home-intro,.dd-pet-door,.dd-brand-door,.dd-product-card,.dd-editorial-card,.dd-discover-title,.dd-account-welcome,.dd-footer-brandline,.dd-promotion-card,.dd-journal-card,.dd-care-doors>a,.dd-care-guide').forEach((element, index) => {
      if (element.dataset.ddObserved) return;
      element.dataset.ddObserved = 'true';
      if (observer && !paused && !reduced.matches && element.getBoundingClientRect().top > window.innerHeight * .85) {
        element.classList.add('dd-reveal-ready');
        element.style.setProperty('--dd-delay', `${(index % 3) * 70}ms`);
        observer.observe(element);
      }
    });
  }
  document.addEventListener('click', event => {
    const languageButton = event.target.closest('[data-dd-lang]');
    if (languageButton) setLanguage(languageButton.dataset.ddLang);
    if (event.target.closest('.dd-motion-toggle')) setPaused(!paused);
    const mascot = event.target.closest('.dd-mascot-button');
    if (mascot) {
      const message = mascot.parentElement.querySelector('.dd-mascot-message');
      if (message) message.textContent = language === 'th' ? 'โฮ่ง! ดีใจที่ได้เจอคุณ ♡' : 'Woof! So happy to see you ♡';
      if (!paused && !reduced.matches) {
        mascot.classList.remove('dd-wave');
        requestAnimationFrame(() => mascot.classList.add('dd-wave'));
        setTimeout(() => mascot.classList.remove('dd-wave'), 850);
      }
    }
    if (event.target.closest('.dd-mobile-menu a')) event.target.closest('.dd-mobile-menu').removeAttribute('open');
  });
  document.addEventListener('focusin', event => { event.target.closest('.dd-reveal-ready')?.classList.add('dd-visible'); });
  document.addEventListener('shopify:section:select', event => { event.target.querySelectorAll('.dd-reveal-ready').forEach(element => element.classList.add('dd-visible')); });
  reduced.addEventListener('change', event => { if (event.matches) setPaused(true); });
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
